var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-sidebar--item",class:[
    { 'vs-sidebar-item-active': _vm.activeLink },
    { 'disabled-item pointer-events-none': _vm.isDisabled },
  ]},[(_vm.to)?_c('router-link',{class:[{ 'router-link-active': _vm.activeLink }],attrs:{"tabindex":"-1","exact":"","to":_vm.to,"target":_vm.target}},[_c('i',{staticClass:"mr-3",class:_vm.icon}),_vm._t("default")],2):_c('a',{attrs:{"target":_vm.target,"href":_vm.href,"tabindex":"-1"}},[_c('vs-icon',{attrs:{"icon-pack":"material-icons","icon":_vm.icon}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }